import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  ReferenceField,
  NumberField,
  ArrayField,
  ImageField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  // RichTextInput,
  ReferenceInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// import { CustomRichTextInput } from '../components/CustomRichTextInput'
import { Paper } from '@mui/material'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const CourseList = ({ isEdit, isDelete }) => (
  <List filters={[]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <ImageField source="imageUrl" title="imageUrl" />
      <RichTextField source="description" />
      <ArrayField source="sections">
        <Datagrid>
          <ReferenceField source="sectionId" reference="sections" />
          <NumberField source="minTimeToProcessInHours" />
          <ReferenceField source="examId" reference="exams" />
        </Datagrid>
      </ArrayField>
      <ReferenceField source="finalExamId" reference="exams" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const CourseEdit = () => (
  <Edit>
    <SimpleForm>
      <ImageInput source="image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="imageUrl" disabled fullWidth />
      {/* <CustomRichTextInput source="description" /> */}
      <TextInput source="description" fullWidth multiline rows={2} />
      <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
        <ArrayInput source="sections" fullWidth>
          <SimpleFormIterator
            fullWidth
            getItemLabel={(index) => `#${index + 1}`}
            sx={{
              // Keep the item label from growing and colliding with iterator action buttons
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
                width: '4ch',
                minWidth: '4ch',
                maxWidth: '4ch',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
              '@media (max-width: 899.95px)': {
                '& .RaSimpleFormIterator-index': {
                  display: 'block !important',
                },
              },
              // Inputs area becomes 1col on mobile, 2col on big screens
              '& .RaSimpleFormIterator-form': {
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  md: '1fr 0.5fr 1fr',
                },
                gap: 1,
                alignItems: 'flex-start',
                width: '100%',
                pt: 1.5,
                flex: '1 0.5 0',
                minWidth: 0,
              },
              '& .RaSimpleFormIterator-action': {
                flexShrink: 0,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <ReferenceInput source="sectionId" reference="sections" perPage={50} />
            <NumberInput source="minTimeToProcessInHours" />
            <ReferenceInput source="examId" reference="exams" perPage={50} />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <ReferenceInput source="finalExamId" reference="exams" fullWidth perPage={50} />
    </SimpleForm>
  </Edit>
)

export const CourseCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" />
      <ImageInput source="image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="imageUrl" disabled fullWidth />
      {/* <CustomRichTextInput source="description" /> */}
      <TextInput source="description" fullWidth multiline rows={2} />
      <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
        <ArrayInput source="sections" fullWidth>
          <SimpleFormIterator
            fullWidth
            getItemLabel={(index) => `#${index + 1}`}
            sx={{
              // Keep the item label from growing and colliding with iterator action buttons
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
                width: '4ch',
                minWidth: '4ch',
                maxWidth: '4ch',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
              '@media (max-width: 899.95px)': {
                '& .RaSimpleFormIterator-index': {
                  display: 'block !important',
                },
              },
              // Inputs area becomes 1col on mobile, 2col on big screens
              '& .RaSimpleFormIterator-form': {
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  md: '1fr 0.5fr 1fr',
                },
                gap: 1,
                alignItems: 'flex-start',
                width: '100%',
                pt: 1.5,
                flex: '1 0.5 0',
                minWidth: 0,
              },
              '& .RaSimpleFormIterator-action': {
                flexShrink: 0,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <ReferenceInput source="sectionId" reference="sections" perPage={50} />
            <NumberInput source="minTimeToProcessInHours" />
            <ReferenceInput source="examId" reference="exams" perPage={50} />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <ReferenceInput source="finalExamId" reference="exams" fullWidth perPage={50} />
    </SimpleForm>
  </Create>
)

export const CourseShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <ImageField source="imageUrl" title="imageUrl" />
      <RichTextField source="description" />
      <ArrayField source="sections">
        <Datagrid>
          <ReferenceField source="sectionId" reference="sections" />
          <NumberField source="minTimeToProcessInHours" />
          <ReferenceField source="examId" reference="exams" />
        </Datagrid>
      </ArrayField>
      <ReferenceField source="finalExamId" reference="exams" />
    </SimpleShowLayout>
  </Show>
)
